import { useCallback, useEffect, useState } from 'react';
import { getNetworkStats } from '../../services/getNetworkStats';

const POLL_INTERVAL_MS = 60000;

export function useNetworkStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    getNetworkStats()
      .then((data) => {
        setStats(data);
        setError(null);
      })
      .catch((err) => {
        setError(err.message || 'Could not load network stats');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    load();
    const interval = setInterval(load, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [load]);

  return { stats, loading, error, reload: load };
}
